import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import { Toaster } from "@/components/ui/sonner";
import { Candlelight } from "@/components/Candlelight";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { EpisodeOne } from "@/components/EpisodeOne";
import { HowItWorks } from "@/components/HowItWorks";
import { Ritual } from "@/components/Ritual";
import { Manifesto } from "@/components/Manifesto";
import { SeasonalShows } from "@/components/SeasonalShows";
import { Signup } from "@/components/Signup";
import { Footer } from "@/components/Footer";

function App() {
  const [interest, setInterest] = useState("the-seance");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    setLenis(lenis);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="min-h-screen bg-obsidian font-sans text-cream antialiased">
      <div className="grain" aria-hidden="true" />
      <Candlelight />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <EpisodeOne />
        <HowItWorks />
        <Ritual />
        <Manifesto />
        <SeasonalShows onNotify={setInterest} />
        <Signup interest={interest} />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#12100E",
            border: "1px solid rgba(226, 177, 93, 0.3)",
            color: "#F4EFEA",
          },
        }}
      />
    </div>
  );
}

export default App;
